import { cn } from '@/lib/utils'

interface PlugIconProps {
  className?: string
}

export function PlugIcon({ className }: PlugIconProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6', className)}
    >
      <path
        d="M14 2V7M10 2V7M6 7H18V10C18 13.3137 15.3137 16 12 16C8.68629 16 6 13.3137 6 10V7Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 16V22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M9 22H15" stroke="var(--color-primary)" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}
